import { render, staticRenderFns } from "./StackedColumns.vue?vue&type=template&id=7638e3f0&scoped=true&"
import script from "./StackedColumns.vue?vue&type=script&lang=js&"
export * from "./StackedColumns.vue?vue&type=script&lang=js&"
import style0 from "./StackedColumns.vue?vue&type=style&index=0&id=7638e3f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7638e3f0",
  null
  
)

export default component.exports